function getChildren(node) {
  if (!node) return []
  if (Array.isArray(node.children)) return node.children
  if (Array.isArray(node.childNods)) return node.childNods
  return []
}

export function normalizeMenuNode(node) {
  const children = getChildren(node)
  return {
    ...node,
    uuid: node.uuid || String(node.menuId || node.code || ''),
    label: node.chineseLabel || node.englishLabel || node.code || String(node.menuId || ''),
    path: node.url || node.h5Path || node.path || '',
    childNods: children.map(normalizeMenuNode)
  }
}

function hasNodePermission(node, parentNode, hasPermission) {
  if (!node || !node.code) return false
  const codes = [node.code, `module_${node.code}`, `report_${node.code}`]
  if (parentNode && parentNode.code) {
    codes.push(`role_${parentNode.code}_${node.code}`)
    codes.push(`report_${parentNode.code}_${node.code}`)
  }
  return codes.some(hasPermission)
}

export function filterMenuTreeByPermission(list, hasPermission, parentNode = null) {
  if (!Array.isArray(list)) return []
  return list.reduce((result, node) => {
    const childNods = filterMenuTreeByPermission(getChildren(node), hasPermission, node)
    const hasOwnPermission = hasNodePermission(node, parentNode, hasPermission)
    if (!hasOwnPermission && childNods.length === 0) {
      return result
    }
    result.push({
      ...normalizeMenuNode(node),
      childNods
    })
    return result
  }, [])
}
